module.exports = __webpack_public_path__ + "static/media/br-balcony.3b3b7016.gif";